<div class="popup-outer" (click)="$event.stopPropagation()">
  <div class="popup-container">
    <div class="popup-top">
      <div class="popup-header">
        <span class="confirm-header" [innerHTML]="title"></span>
      </div>
      <div class="popup-exit">
        <i class="icon-x" title="Close the window" (click)="dismiss()"></i>
      </div>
    </div>
    <div class="popup-bottom">
      <div class="confirm-outer">
        <div class="confirm-body" [innerHTML]="message">

        </div>
        <div class="confirm-buttons">
          <button type="button" class="btn btn-primary" (click)="dismiss()">{{ buttonText }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
